<template>
  <div class="about">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <h3 class="title">Create Account</h3>
            <p class="subtitle">
              Start now on the free plan and upgrade later.
            </p>
            <div class="box">
              <div v-if="registerError" class="notification is-danger">
                Sorry, an error occured during creating your account:
                <br />
                {{ registerErrorMsg }}
              </div>

              <div
                v-if="registerAttemptSuccess"
                class="notification is-success"
              >
                Hurray, great to see you. One step is left. We sent you a email
                with an activation link and you need to confirm your account.
                Check your SPAM folder too.
              </div>
              <form @submit.prevent="attemptRegister">
                <div class="field">
                  <div class="control">
                    <input
                      v-model="email"
                      required
                      class="input"
                      type="email"
                      placeholder="Your Email"
                      autofocus
                    />
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input
                      v-model="password"
                      required
                      class="input"
                      type="password"
                      placeholder="Your Password"
                      minlength="8"
                    />
                  </div>
                </div>
                <button
                  v-bind:class="{ 'is-loading': loading }"
                  class="button is-block is-primary is-fullwidth"
                >
                  Register
                </button>
              </form>
            </div>
            <p class="has-text-grey">
              <router-link to="/login">Login</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import atomic from "atomicjs";
export default {
  name: "Register",
  data: function () {
    return {
      registerError: false,
      registerErrorMsg: "",
      registerAttemptSuccess: false,
      password: null,
      email: null,
      loading: false,
    };
  },
  methods: {
    attemptRegister: function () {
      this.registerError = false;
      this.loading = true;
      var data = {
        email: this.email,
        password: this.password,
      };
      atomic(this.apiHost + "auth/register", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        data: data,
      })
        .then((response) => {
          console.log("Confirmation email sent", response);
          this.registerAttemptSuccess = true;
          this.password = null;
          this.email = null;
          this.loading = false;
          //this.$parent.trackPageView(this.triggerView + "_reg")
        })
        .catch((error) => {
          console.log("It's an error", error);
          this.registerError = true;
          this.loading = false;
          if (error.responseText.trim() == "ERROR_EMAIL_REGISTERED") {
            this.registerErrorMsg = "There's already an account registered with this email address.";
          } else if (error.responseText.trim() == "ERROR_INVALID_EMAIL") {
            this.registerErrorMsg = "Not a valid email address."
          } else if (error.responseText.trim() == "ERROR_INVALID_PASSWORD") {
            this.registerErrorMsg = "Password is too short. Must be at least 8 characters long."
          } else {
            this.registerErrorMsg = "OMG, something went wrong. It was us, not you and the team was already notified. Please try again later."
          }
        });
    },
  },
};
</script>

